<div class="map-container" >
  <div class="map-frame" >
    <div id="map" #map [style.height.px]="mapheight"></div>
  </div>
  <div class="control-frame">
    <button class="btn btn-sm btn-white"  (click)="changeLayer(tiles)">Open Street Map</button>
    <button class="btn btn-sm btn-white"  (click)="changeLayer(googleTerrain)">Terrain</button>
    <button class="btn btn-sm btn-white"  (click)="changeLayer(googleStreets)">Streets</button>
    <button class="btn btn-sm btn-white"  (click)="changeLayer(googleSat)">Satellite</button>
  </div>
  <div class="layer-manager" *ngIf="linkLayers">
    <ul>
      <li *ngFor="let layer of linkLayers | keyvalue">
        <button class="btn btn-sm btn-white" [ngClass]="{'selected':layer.value.visible, 'error': layer.value.error}" (click)="showLinkLayer(layer.key)">{{layer.key}}</button>
      </li>
    </ul>
  </div>
</div> 